export const add = items => {
    const body = JSON.stringify({ items });
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body,
    });
};

export const remove = () => {};

export const update = () => {};

